import { render, staticRenderFns } from "./AddTaskNotes.vue?vue&type=template&id=70d6786e&scoped=true&"
import script from "./AddTaskNotes.vue?vue&type=script&lang=js&"
export * from "./AddTaskNotes.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskNotes.vue?vue&type=style&index=0&id=70d6786e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6786e",
  null
  
)

export default component.exports